import React from 'react';
import { Grid, Typography, Divider } from '@mui/material';
import useStyles from './styles';
export default function SubscriptionSummary(_ref) {
  let _ref$summaryData = _ref.summaryData,
    summaryData = _ref$summaryData === void 0 ? {} : _ref$summaryData;
  const classes = useStyles();
  const propertiesValue = summaryData.propertiesValue,
    unitsValue = summaryData.unitsValue,
    nextPayment = summaryData.nextPayment,
    nextPaymentDate = summaryData.nextPaymentDate,
    paperInvite = summaryData.paperInvite,
    paperStatement = summaryData.paperStatement;
  const getValue = function (value) {
    let dollarSign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    let suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return !value ? 'N/A' : "".concat(dollarSign ? '$' : '').concat(value + suffix);
  };
  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 7,
    md: 7,
    className: classes.infoContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 0.25
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4,
    sm: 2,
    md: 2,
    lg: true,
    className: classes.info
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.summaryCell
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, 'Properties'), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, getValue(propertiesValue)))), /*#__PURE__*/React.createElement(Divider, {
    orientation: "vertical",
    variant: "middle",
    flexItem: true,
    sx: {
      mr: '-1px'
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4,
    sm: 2,
    md: 2,
    lg: true,
    className: classes.info
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.summaryCell
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, 'Units'), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, getValue(unitsValue)))), /*#__PURE__*/React.createElement(Divider, {
    orientation: "vertical",
    variant: "middle",
    flexItem: true,
    sx: {
      mr: '-1px'
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4,
    sm: 4,
    md: 4,
    lg: true,
    className: classes.info
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.summaryCell
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, "Next payment ".concat(nextPaymentDate)), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, getValue(nextPayment, true)))), /*#__PURE__*/React.createElement(Divider, {
    orientation: "vertical",
    variant: "middle",
    flexItem: true,
    sx: {
      mr: '-1px'
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4,
    sm: 2,
    md: 2,
    lg: true,
    className: classes.info
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.summaryCell
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, 'Paper invite'), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, getValue(paperInvite, true, '/each')))), /*#__PURE__*/React.createElement(Divider, {
    orientation: "vertical",
    variant: "middle",
    flexItem: true,
    sx: {
      mr: '-1px'
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4,
    sm: 2,
    md: 2,
    lg: true,
    className: classes.info
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.summaryCell
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, 'Paper statement'), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, getValue(paperStatement, true, '/each'))))));
}